import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SharedModule } from './shared/shared.module';
import { LayoutModule } from '@layout/layout.module';

//Translation
import { TranslateModule } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';

import { registerLocaleData } from '@angular/common';
import LocaleEn from '@angular/common/locales/en';
import LocaleEs from '@angular/common/locales/es';

import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { HeadersInterceptor } from './shared/interceptors/headers.interceptor';
import { OperationMapperService } from './shared/mappers/operation-mapper';

registerLocaleData(LocaleEs, 'es');
registerLocaleData(LocaleEn, 'en');

@NgModule({
    declarations: [AppComponent],
    providers: [HttpClient, { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true }],
    bootstrap: [AppComponent],
    imports: [
        BrowserAnimationsModule,
        NoopAnimationsModule,
        SharedModule,
        LayoutModule,
        AppRoutingModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (http: HttpClient) => {
                    return new TranslateHttpLoader(http);
                },
                deps: [HttpClient],
            },
        }),
    ],
    exports: [BrowserAnimationsModule, NoopAnimationsModule, TranslateModule, AppRoutingModule, HttpClientModule],
})
export class AppModule {}
